/**
 * Number of users to load per page/scroll
 * @constant {number}
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Distance from bottom (in pixels) to trigger infinite scroll load
 * @constant {number}
 */
export const SCROLL_THRESHOLD_PIXELS = 300;

/**
 * Throttle delay for scroll events (in milliseconds)
 * @constant {number}
 */
export const SCROLL_THROTTLE_DELAY = 200;

/**
 * Debounce delay for search input (in milliseconds)
 * @constant {number}
 */
export const DEBOUNCE_DELAY = 500;

/**
 * Super Admin role ID (protected from modifications)
 * @constant {number}
 */
export const SUPER_ADMIN_ROLE_ID = 1;

/**
 * User status values
 * @constant {Object}
 */
export const USER_STATUS = {
  ACTIVE: true,
  INACTIVE: false,
};

/**
 * Status options for filters and display
 * @constant {Array<{label: string, value: boolean}>}
 */
export const STATUS_OPTIONS = [
  { label: "Active", value: USER_STATUS.ACTIVE },
  { label: "Inactive", value: USER_STATUS.INACTIVE },
];

/**
 * Initial state for modals
 * @constant {Object}
 */
export const INITIAL_MODAL_STATE = {
  visible: false,
  userId: null,
  userName: "",
  userEmail: "",
};

/**
 * Password validation rules
 * @constant {Object}
 */
export const PASSWORD_RULES = {
  MIN_LENGTH: 8,
  REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
  REQUIREMENTS:
    "Password must be at least 8 characters with uppercase, lowercase and numbers",
};

/**
 * Permission dependencies for enforcing view access
 * Modules listed here require view permission when certain actions are enabled
 */
export const DEPENDENCY_MODULES = new Set(['users', 'agents']);
export const DEPENDENT_ACTIONS = ['create', 'update', 'delete', 'reset_password'];

/**
 * Success messages for different operations
 * @constant {Object}
 */
export const SUCCESS_MESSAGES = {
  USER_ACTIVATED: "User activated successfully",
  USER_DEACTIVATED: "User deleted successfully",
  USER_CREATED: "User created successfully",
  USER_UPDATED: "User updated successfully",
  USER_DELETED: "User deleted permanently",
  PASSWORD_RESET: "Password reset successfully",
  ROLE_CHANGED: (role) => `User role changed to ${role} successfully`,
};

/**
 * Error messages for different operations
 * @constant {Object}
 */
export const ERROR_MESSAGES = {
  LOAD_USERS_FAILED: "Failed to load users. Please try again.",
  LOAD_STATS_FAILED: "Failed to load statistics",
  UPDATE_STATUS_FAILED: "Failed to update user status",
  UPDATE_ROLE_FAILED: "Failed to update user role",
  DELETE_USER_FAILED: "Failed to delete user",
  PASSWORD_RESET_FAILED: "Failed to reset password",
  FORM_VALIDATION_FAILED: "Please fix the errors in the form",
};